/* PROA-OLHO: o que corre mal no telemóvel das clientes, e o que elas usam.
   A história e os porquês estão em `proa/ESTADO.md`: aqui cada linha pesa à cliente.
   ⛔ O CONSENTIMENTO VEM PRIMEIRO. Sem `analyticsProcessingAllowed()` nada sai, e isso
   vale a qualquer momento, mesmo retirado a meio da visita (ver `desligar`).
   ⛔ Nunca cookies nossos, `localStorage`, IP, nem texto escrito pela cliente.
   ⛔ 6 KB no máximo com gzip. A trava do tema mede-o e recusa. */
(function () {
  "use strict";

  // ⚠️ Trava de reentrada. Um erro DENTRO de um dos nossos próprios apanhadores
  // não pode voltar a chamar o apanhador, senão a página morre num ciclo.
  var aTratar = false;
  function seguro(fn) {
    return function () {
      if (aTratar) return;
      aTratar = true;
      try { fn.apply(this, arguments); } catch (e) { /* nunca deixa subir */ }
      finally { aTratar = false; }
    };
  }

  var CFG_EL = document.getElementById("proa-olho-cfg");
  if (!CFG_EL) return;
  var CFG;
  try { CFG = JSON.parse(CFG_EL.textContent); } catch (e) { return; }
  if (!CFG || !CFG.endereco) return;

  // 03/10/2026: robôs conhecidos não se medem; lista fechada, nunca «bot» solto (CUBOT)
  var ROBOS = /(meta-externalads|facebookexternalhit|facebookcatalog|googlebot|adsbot-google|storebot-google|bingbot|yandexbot|applebot|petalbot|semrushbot|ahrefsbot|bytespider|gptbot|claudebot|perplexitybot|headlesschrome|lighthouse)/i;
  try { if (navigator.webdriver === true || ROBOS.test(navigator.userAgent || "")) return; } catch (e) {}

  var fetchOriginal = window.fetch;
  var XHROriginal = window.XMLHttpRequest;

  // O CONTEXTO DE CADA ENVIO (o formato do pacote A do olho)
  function largura() {
    var w = innerWidth;
    return w < 400 ? "<400" : w < 768 ? "400-767" : w < 1024 ? "768-1023" : "1024+";
  }
  function dispositivo() {
    return /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent) ? "tel" : "pc";
  }
  function ligacao() {
    var c = navigator.connection;
    var t = c && c.effectiveType;
    return (t === "slow-2g" || t === "2g" || t === "3g" || t === "4g") ? t : null;
  }
  function caminho() {
    var v = null;
    try { v = new URLSearchParams(location.search).get("variant"); } catch (e) {}
    return v ? location.pathname + "?variant=" + v : location.pathname;
  }
  function cortar(s, n) { return s == null ? undefined : String(s).slice(0, n); }

  var MODELOS_CONHECIDOS = {
    product: 1, collection: 1, index: 1, search: 1, cart: 1, page: 1,
    blog: 1, article: 1, "404": 1, "list-collections": 1,
  };
  var MODELO = (function () {
    var t = String(CFG.tpl || "").split(".")[0];
    return MODELOS_CONHECIDOS[t] ? t : "other";
  })();

  // Um seletor curto e sem texto da cliente: tag, id ou até 2 classes.
  function seletor(el) {
    if (!el || el === document || el === window || !el.tagName) return "";
    var s = el.tagName.toLowerCase();
    if (el.id) s += "#" + el.id;
    else if (typeof el.className === "string" && el.className.trim()) {
      var cs = el.className.trim().split(/\s+/).filter(Boolean).slice(0, 2);
      if (cs.length) s += "." + cs.join(".");
    }
    return s.slice(0, 120);
  }

  // A FILA E O ENVIO. A mesma impressão só uma vez por página, 60 eventos no máximo.
  var MAX_POR_PAGINA = 60;
  var contagemPagina = 0;
  var vistasNaPagina = {};
  var fila = [];
  var consentimentoOk = false;
  var arrancou = false;

  function chaveDeImpressao(ev) {
    if (ev.k === "carrinho") {
      if (ev.res === "ok") return null;
      return "carrinho|" + ev.res + "|" + cortar(ev.msg, 80);
    }
    if (ev.k === "erro_js" || ev.k === "recurso" || ev.k === "imagem_partida" ||
        ev.k === "pagina_404" || ev.k === "clique_repetido" || ev.k === "clique_morto" ||
        ev.k === "uso") {
      return ev.k + "|" + cortar(ev.msg || ev.el || ev.fich || ev.src || ev.origem, 80) +
        "|" + cortar(ev.fich, 80);
    }
    return null;
  }

  function empilhar(ev) {
    if (!consentimentoOk) return;
    if (contagemPagina >= MAX_POR_PAGINA) return;
    var chave = chaveDeImpressao(ev);
    if (chave) {
      if (vistasNaPagina[chave]) return;
      vistasNaPagina[chave] = true;
    }
    contagemPagina++;
    fila.push(ev);
    if (fila.length >= 20) mandar();
  }

  // Confirma outra vez, encostado ao envio: o consentimento pode sair a meio da visita.
  function temConsentimentoAgora() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === "function" && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function mandar() {
    if (!consentimentoOk || !fila.length) return;
    if (!temConsentimentoAgora()) { desligar(); return; } // retirado entretanto: deita fora, não envia
    var lote = fila.splice(0, 20);
    var corpo = {
      v: 1, t: CFG.t, tp: CFG.tp, tv: CFG.tv,
      m: MODELO, h: CFG.h || null, c: caminho(),
      l: largura(), d: dispositivo(), r: ligacao(),
      e: lote,
    };
    try { navigator.sendBeacon(CFG.endereco, JSON.stringify(corpo)); } catch (e) {}
    // ⚠️ O resto da fila vai no envio seguinte (o servidor recusa acima de 20).
  }

  // Drena o que o apanhador do <head> guardou.
  // ⚠️ NUNCA `window.__proaFila = []`: o apanhador guarda-a por REFERÊNCIA. Esvazia-se o
  // MESMO array, com `.length = 0`.
  function drenarFilaInicial() {
    var f = window.__proaFila;
    if (f && f.length) { for (var i = 0; i < f.length; i++) empilhar(f[i]); f.length = 0; }
  }

  // A VELOCIDADE: LCP, INP, CLS, TTFB
  function ligarVelocidade() {
    try {
      new PerformanceObserver(seguro(function (lista) {
        var entradas = lista.getEntries();
        var ultima = entradas[entradas.length - 1];
        if (ultima) empilhar({ k: "lcp", ms: Math.round(ultima.startTime), el: seletor(ultima.element) });
      })).observe({ type: "largest-contentful-paint", buffered: true });
    } catch (e) {}

    try {
      new PerformanceObserver(seguro(function (lista) {
        var entradas = lista.getEntries();
        for (var i = 0; i < entradas.length; i++) {
          if (entradas[i].interactionId) empilhar({ k: "inp", ms: Math.round(entradas[i].duration), el: seletor(entradas[i].target) });   // 11/10 · o alvo do toque, para saber ONDE a página está lenta
        }
      })).observe({ type: "event", buffered: true, durationThreshold: 40 });
    } catch (e) {}

    try {
      var clsValor = 0;
      new PerformanceObserver(seguro(function (lista) {
        var entradas = lista.getEntries();
        for (var i = 0; i < entradas.length; i++) {
          if (!entradas[i].hadRecentInput) clsValor += entradas[i].value;
        }
      })).observe({ type: "layout-shift", buffered: true });
      addEventListener("visibilitychange", seguro(function () {
        if (document.visibilityState === "hidden" && clsValor > 0) {
          empilhar({ k: "cls", v: Math.round(clsValor * 10000) / 10000 });
        }
      }));
    } catch (e) {}

    try {
      var nav = performance.getEntriesByType("navigation")[0];
      if (nav) empilhar({ k: "ttfb", ms: Math.round(nav.responseStart) });
    } catch (e) {}
  }

  // A IMAGEM PARTIDA: carregou (200 OK, ao contrário do "recurso" do <head>) mas ficou
  // sem largura nenhuma.
  function ligarImagemPartida() {
    addEventListener("load", seguro(function (e) {
      var el = e.target;
      if (el && el.tagName === "IMG" && el.naturalWidth === 0) {
        empilhar({ k: "imagem_partida", src: cortar(el.currentSrc || el.src, 300) });
      }
    }), true);
  }

  // O CARRINHO: /cart/add e /cart/change, e "carregou em comprar e nada aconteceu em 3 s".
  var RE_CARRINHO = /\/cart\/(add|change)(\.js)?(\?|$)/;
  var pendenteComprar = null;

  // Aviso genérico de "houve um pedido", para o clique morto saber que algo aconteceu.
  var ouvintesDePedido = [];
  function avisarPedido() {
    for (var i = 0; i < ouvintesDePedido.length; i++) { try { ouvintesDePedido[i](); } catch (e) {} }
  }
  function vigiarPedido(fn) {
    ouvintesDePedido.push(fn);
    return function () {
      var i = ouvintesDePedido.indexOf(fn);
      if (i >= 0) ouvintesDePedido.splice(i, 1);
    };
  }

  function reportarCarrinho(op, res, msg, ms) {
    empilhar({ k: "carrinho", op: op, res: res, msg: cortar(msg, 300), ms: ms });
  }

  function ligarCarrinho() {
    if (fetchOriginal) {
      window.fetch = function () {
        avisarPedido();
        var args = arguments;
        var url = String((args[0] && args[0].url) || args[0] || "");
        if (!RE_CARRINHO.test(url)) return fetchOriginal.apply(this, args);
        pendenteComprar = null; // vai chegar uma resposta: cancela o "sem_resposta"
        var op = /change/.test(url) ? "change" : "add";
        var t0 = Date.now();
        return fetchOriginal.apply(this, args).then(function (r) {
          var ms = Date.now() - t0;
          if (r.ok) { reportarCarrinho(op, "ok", null, ms); return r; }
          if (r.status === 422) {
            return r.clone().json().then(seguro(function (j) {
              reportarCarrinho(op, "422", (j && (j.description || j.message)) || null, ms);
            })).catch(function () {}).then(function () { return r; });
          }
          reportarCarrinho(op, "outro", String(r.status), ms);
          return r;
        }, function (erro) {
          reportarCarrinho(op, "rede", erro && erro.message, Date.now() - t0);
          throw erro;
        });
      };
    }

    if (XHROriginal) {
      var abrirOriginal = XHROriginal.prototype.open;
      var mandarOriginal = XHROriginal.prototype.send;
      XHROriginal.prototype.open = function (metodo, url) {
        this.__proaUrl = String(url || "");
        this.__proaEhCarrinho = RE_CARRINHO.test(this.__proaUrl);
        return abrirOriginal.apply(this, arguments);
      };
      XHROriginal.prototype.send = function () {
        avisarPedido();
        if (this.__proaEhCarrinho) {
          pendenteComprar = null;
          var op = /change/.test(this.__proaUrl) ? "change" : "add";
          var t0 = Date.now();
          var xhr = this;
          xhr.addEventListener("load", seguro(function () {
            var ms = Date.now() - t0;
            if (xhr.status >= 200 && xhr.status < 300) { reportarCarrinho(op, "ok", null, ms); return; }
            if (xhr.status === 422) {
              var msg = null;
              try { var j = JSON.parse(xhr.responseText); msg = (j && (j.description || j.message)) || null; } catch (e) {}
              reportarCarrinho(op, "422", msg, ms);
              return;
            }
            reportarCarrinho(op, "outro", String(xhr.status), ms);
          }));
          xhr.addEventListener("error", seguro(function () {
            reportarCarrinho(op, "rede", null, Date.now() - t0);
          }));
        }
        return mandarOriginal.apply(this, arguments);
      };
    }
  }

  // O clique no botão de comprar A SÉRIO: sem nenhum pedido de carrinho em 3 s, é "sem_resposta".
  // ⚠️ Só `[type="submit"]` ou `[name="add"]`: o "−"/"+" e os do "Avisa-me" vivem no MESMO
  // `<form>` e são `type="button"` (o porquê inteiro está em `proa/ESTADO.md`).
  var SELETOR_COMPRAR = 'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]';
  var NAO_E_COMPRAR = /\bbis-|itpBis/i; // o "Avisa-me quando voltar" (Back In Stock)
  function ligarCliqueDeComprar() {
    document.addEventListener("click", seguro(function (e) {
      var alvo = e.target.closest && e.target.closest(SELETOR_COMPRAR);
      if (!alvo) return;
      // Defesa a mais: nunca um `type="button"`, nunca um botão do "Avisa-me".
      if (alvo.getAttribute("type") === "button") return;
      if (NAO_E_COMPRAR.test(alvo.id || "") || NAO_E_COMPRAR.test(alvo.className || "")) return;
      var marca = Date.now();
      pendenteComprar = marca;
      setTimeout(seguro(function () {
        if (pendenteComprar === marca) {
          reportarCarrinho("add", "sem_resposta", null, null);
          pendenteComprar = null;
        }
      }), 3000);
    }), true);
  }

  // travão do vigia do stock: erro evitado
  function ligarVigia() {
    document.addEventListener("proa:vigia", seguro(function (e) {
      // vai o motivo cru (esgotado | carrinho | quantidade); a frase escreve-se no painel
      pendenteComprar = null;
      reportarCarrinho("add", "vigia", (e && e.detail && e.detail.motivo) || "esgotado", null);
    }));
  }

  // OS CLIQUES: repetidos e mortos (só com consentimento, como o resto)
  function ligarCliques() {
    var recentes = [];
    document.addEventListener("click", seguro(function (e) {
      var agora = Date.now();
      recentes.push({ t: agora, x: e.clientX, y: e.clientY, el: e.target });
      recentes = recentes.filter(function (c) { return agora - c.t <= 1000; });
      if (recentes.length >= 3) {
        var base = recentes[recentes.length - 1];
        var perto = recentes.filter(function (c) {
          return Math.hypot(c.x - base.x, c.y - base.y) <= 30;
        });
        if (perto.length >= 3) empilhar({ k: "clique_repetido", el: seletor(base.el) });
      }
    }), true);

    var SELETOR_CLICAVEL = 'a, button, [role="button"], input[type="submit"], summary, label';
    document.addEventListener("click", seguro(function (e) {
      var el = e.target.closest && e.target.closest(SELETOR_CLICAVEL);
      if (!el) return;

      var houveMutacao = false;
      var obs = new MutationObserver(function () { houveMutacao = true; });
      obs.observe(document.body, { childList: true, subtree: true, attributes: true });

      var houvePedido = false;
      var pararDeVigiar = vigiarPedido(function () { houvePedido = true; });

      var urlAntes = location.href;
      setTimeout(seguro(function () {
        obs.disconnect();
        pararDeVigiar();
        if (!houveMutacao && !houvePedido && location.href === urlAntes) {
          empilhar({ k: "clique_morto", el: seletor(el) });
        }
      }), 1000);
    }), true);
  }

  // O USO dos comandos da coleção: um por comando e por página. O botão já ativo não conta.
  function ligarUso() {
    if (MODELO !== "collection") return;
    var LISTA = '[data-layout-mode="list"]', ATIVO = ".btn--active";
    function uso(el) { empilhar({ k: "uso", el: el }); }
    function ouvir(tipo, pares) {
      document.addEventListener(tipo, seguro(function (e) {
        var a = e.target, i;
        if (!a || !a.closest) return;
        for (i = 0; i < pares.length; i += 2) {
          if (a.closest(pares[i])) return uso(pares[i + 1]);
        }
      }), true);
    }
    ouvir("click", [LISTA + ":not(" + ATIVO + ")", "ver_lista", "[data-layout-mode]:not(" + ATIVO + ")", "ver_grelha",
      ".facet-drawer-button", "filtro_abrir", ".facet-remove", "filtro_usar",
      ".pagination a[href]", "pagina", '[is="load-more-button"]', "carregar_mais"]);
    ouvir("change", ['[name="sort_by"]', "ordenar", "compare-switch", "comparar",
      '[name^="filter."]', "filtro_usar"]);
    // O tema guarda a lista de página para página: quem a vê em lista conta.
    setTimeout(seguro(function () { if (document.querySelector(LISTA + ATIVO)) uso("em_lista"); }), 3000);
  }

  // O ARRANQUE. Liga-se tudo UMA vez; só se enfileira e envia com `consentimentoOk`.
  var idDoIntervalo = null;

  function pararIntervalo() {
    if (idDoIntervalo !== null) { clearInterval(idDoIntervalo); idDoIntervalo = null; }
  }
  function arrancarIntervalo() {
    if (idDoIntervalo !== null) return;
    idDoIntervalo = setInterval(seguro(function () { drenarFilaInicial(); mandar(); }), 10000);
  }

  function ligar() { // 1ª vez ou de volta, com consentimento
    consentimentoOk = true;
    drenarFilaInicial();
    arrancarIntervalo();
  }

  function desligar() { // sem consentimento, ou retirado a meio: observadores ficam, envio para
    consentimentoOk = false;
    fila.length = 0;
    pararIntervalo();
    if (window.__proaFila) window.__proaFila.length = 0;
  }

  function iniciar() {
    if (arrancou) return;
    arrancou = true;

    ligarVelocidade();
    ligarImagemPartida();
    ligarCarrinho();
    ligarCliqueDeComprar();
    ligarVigia();
    ligarCliques();
    ligarUso();

    addEventListener("visibilitychange", seguro(function () {
      if (document.visibilityState === "hidden") mandar();
    }));
    addEventListener("pagehide", seguro(mandar));

    ligar();
    empilhar({ k: "vista" });
    if (MODELO === "404") {
      try {
        var ref = new URL(document.referrer);
        if (ref.origin === location.origin) empilhar({ k: "pagina_404", origem: cortar(ref.pathname, 300) });
      } catch (e) {}
    }
  }

  function verificarConsentimento() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== "function") return;
      if (cp.analyticsProcessingAllowed()) { if (!arrancou) iniciar(); else ligar(); return; }
      desligar();
    } catch (e) {}
  }

  // Arranca quando a cliente aceitar a meio da visita.
  document.addEventListener("visitorConsentCollected", seguro(verificarConsentimento));

  if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (erro) {
      if (!erro) verificarConsentimento();
    });
  }
  // Sem `Shopify.loadFeatures` não se mede nada até ao `visitorConsentCollected`.
})();
